import { compose, display, size, layout, position, background, color, border, alignSelf, justifySelf, flexbox } from 'styled-system';
import { strictSpace } from '../../utils';
var expandedLayoutProps = compose(display, layout, size, position, background, color, border, alignSelf, justifySelf, strictSpace, flexbox);
export default expandedLayoutProps;